import { Action, createReducer, on } from '@ngrx/store';
import {
    loadContractAssignmentByContractIdFailure,
    loadContractAssignmentByContractIdSuccessfully,
    updateContractCredentialingSpecialistSuccessfully,
    updateContractComplianceLiaisonSuccessfully
} from 'src/app/compliance/store/actions/compliance.actions';
import { ComplianceReportState } from 'src/app/compliance/store/state/compliance-report.state';
import * as complianceReportActions from 'src/app/compliance/store/actions/compliance-report.actions';

const initialState = {
    contractAssignment: [],
    autoMatchSignalResponse: undefined,
    error: undefined
} as ComplianceReportState;

const reducer = createReducer(
    initialState,

    on(loadContractAssignmentByContractIdSuccessfully, (state, action) => ({
        ...state,
        contractAssignment: action.assignment,
        error: undefined
    })),

    on(loadContractAssignmentByContractIdFailure, (state, action) => ({
        ...state,
        contractAssignment: undefined,
        error: action.error
    })),

    on(
        updateContractCredentialingSpecialistSuccessfully,
        updateContractComplianceLiaisonSuccessfully,
        (state, action) => ({
            ...state,
            contractAssignment: [action.res[Object.keys(action.res)[0]]],
            error: undefined
        })
    ),

    on(complianceReportActions.autoMatchResponseSuccess, (state, action) => ({
        ...state,
        autoMatchSignalResponse: action.data
    })),

    on(complianceReportActions.autoMatchResponseFailure, (state, action) => ({
        ...state,
        error: action.error
    })),

    on(complianceReportActions.markAsReviewedSuccess, (state, action) => ({
        ...state
    }))
);

export function complianceReportReducer(state: ComplianceReportState | undefined, action: Action) {
    return reducer(state, action);
}
